// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingCartLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 19.125h9.92a1.5 1.5 0 0 0 1.48-1.249l2.637-15.5a1.5 1.5 0 0 1 1.479-1.248h.984M7.875 21.375a.375.375 0 1 0 .375.37.374.374 0 0 0-.375-.374m7.5.004a.375.375 0 1 0 .375.37.375.375 0 0 0-.375-.374m2.578-6.746H5.882a3 3 0 0 1-2.91-2.272l-1.45-5.8a.75.75 0 0 1 .728-.932h17.234"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ShoppingCartLineOffset: IconOffset = {
    vertical: 0, // Store Custom Code
    horizontal: 1, // Store Custom Code
};

export default React.memo(ShoppingCartLine);
